import React from 'react';
import './Chaves.css';
import useLoadState from './useLoadState.js';
import Clube from './Clube.js';
import * as generic from './generic.js';
import { useState, useEffect } from 'react';

import imgCampeao from './assets/2022copa.svg';

function Jogo(props) {
	let jogo = props.jogo;
	let simulados = props.simulados || {};
	let ida_volta = props.ida_volta;
	let count = props.count;
	let updateSimulado = props.updateSimulado;
	let extra_jogos = props.extra_jogos;

	let simuladosIda = simulados[jogo.id] || {};
	let simuladosVolta = simulados[jogo.volta?.id] || {};

	let pontos_mandante = parseInt(jogo.placarm_tn || 0) + parseInt(jogo.placarm_pr || 0) + parseInt(jogo.placarm_pe || 0);
	let pontos_visitante = parseInt(jogo.placarv_tn || 0) + parseInt(jogo.placarv_pr || 0) + parseInt(jogo.placarv_pe || 0);
	let completo = (!jogo.simular && jogo.id_periodo == 5) || jogo.simulado;
	if (jogo.volta) {
		pontos_mandante += parseInt(jogo.volta.placarv_tn || 0) + parseInt(jogo.volta.placarv_pr || 0) + parseInt(jogo.volta.placarv_pe || 0);
		pontos_visitante += parseInt(jogo.volta.placarm_tn || 0) + parseInt(jogo.volta.placarm_pr || 0) + parseInt(jogo.volta.placarm_pe || 0);
		completo = completo && ((!jogo.volta.simular && jogo.volta.id_periodo == 5)|| jogo.volta.simulado);
	}

	if (!props.showAllSimulados && (Object.keys(props.primeira_posicao || {}).length > 0 || Object.keys(props.segunda_posicao || {}).length > 0)) {
		if (
			Object.values(props.primeira_posicao).map((v) => parseInt(v)).indexOf(parseInt(jogo.id_clubem)) === -1 &&
			Object.values(props.segunda_posicao).map((v) => parseInt(v)).indexOf(parseInt(jogo.id_clubem)) === -1
		) {
			jogo.id_clubem = null;
		}
		if (
			Object.values(props.primeira_posicao).map((v) => parseInt(v)).indexOf(parseInt(jogo.id_clubev)) === -1 &&
			Object.values(props.segunda_posicao).map((v) => parseInt(v)).indexOf(parseInt(jogo.id_clubev)) === -1
		) {
			jogo.id_clubev = null;
		}
	}

	let classMandante = "";
	let classVisitante = "";

	if (pontos_visitante > pontos_mandante) {
		classMandante = "gray";

	} else if (pontos_mandante > pontos_visitante) {
		classVisitante = "gray";
	}

	return (
		<div className={"chave" + (props["no-lines"] ? " no-lines" : "")}>
			<div>
				{completo && count === 1 && pontos_visitante != pontos_mandante ?
					<div className="campeao">
						<img alt="" src={imgCampeao}/>
						<Clube clubeMap={props.clubeMap} clube={pontos_mandante > pontos_visitante ? jogo.id_clubem : jogo.id_clubev}/>
					</div>
				:
					null
				}
				<div className="comment">{generic.fmtDataHora(jogo.datahora, "A definir")} {jogo.estadio}</div>
				<div className="jogo">
					<Clube onClick={props.editable ? () => {
						updateSimulado(jogo.id, 'placarm_tn', 3, 'placarv_tn', 0);
					} : null} clubeMap={props.clubeMap} clube={jogo.id_clubem} className={classMandante + " e100 ellipsis"} />
					<div className="placar">
						{jogo.id_periodo === "5" ? [
							jogo.placarm_tn,
							jogo.penaltis === "S" ? <div className="penalti">{jogo.placarm_pe}</div> : null
						] :
							(props.editable ?
								<input value={simuladosIda["placarm_tn"] || ""} onChange={(e) => updateSimulado(jogo.id, 'placarm_tn', e.target.value)}/>
							:
								null
							)
						}
					</div>
					{ida_volta > 0 ?
						<div className="placar">
							{jogo.volta?.id_periodo === "5" ? [
								jogo.volta?.placarv_tn,
								jogo.volta?.penaltis === "S" ? <div className="penalti">{jogo.volta?.placarv_pe}</div> : null
							] :
								(props.editable ?
									<input value={simuladosVolta["placarv_tn"] || ""} onChange={(e) => updateSimulado(jogo.volta.id, 'placarv_tn', e.target.value)}/>
								:
									null
								)
							}
						</div>
					:
						null
					}
					<div className="placar_x">
						x
					</div>
					<div className="placar">
						{jogo.id_periodo === "5" ? [
							jogo.placarv_tn,
							jogo.penaltis === "S" ? <div className="penalti">{jogo.placarv_pe}</div> : null
						] :
							(props.editable ?
								<input value={simuladosIda["placarv_tn"] || ""} onChange={(e) => updateSimulado(jogo.id, 'placarv_tn', e.target.value)}/>
							:
								null
							)
						}
					</div>
					{ida_volta > 0 ?
						<div className="placar">
							{jogo.volta?.id_periodo === "5" ? [
								jogo.volta?.placarm_tn,
								jogo.volta?.penaltis === "S" ? <div className="penalti">{jogo.volta?.placarm_pe}</div> : null
							] :
								(props.editable ?
									<input value={simuladosVolta["placarm_tn"] || ""} onChange={(e) => updateSimulado(jogo.volta.id, 'placarm_tn', e.target.value)}/>
								:
									null
								)
							}
						</div>
					:
						null
					}
					<Clube onClick={props.editable ? () => {
						updateSimulado(jogo.id, 'placarm_tn', 0, 'placarv_tn', 3);
					} : null} clubeMap={props.clubeMap} clube={jogo.id_clubev} className={classVisitante + " e100 ellipsis"} />
				</div>
				{ida_volta > 0 ?
					<div className="comment">{generic.fmtDataHora(jogo.volta?.datahora, "A definir")} {jogo.volta?.estadio}</div>
				:
					null
				}
			</div>
			<div>
				{(extra_jogos ?
					<>
						<span className="jogo-space"/>
						<span className="column e0 extra-jogo " style={{padding: "0"}}>
							<div className="column-header small">Disputa terceiro lugar</div>
							<span className="column-legenda">Toque no Nome/Bandeira da Seleção para escolher a Terceira Colocada</span>
							{extra_jogos.map((jogo,i) => {
								return <Jogo key={i}
									clubeMap={props.clubeMap}
									editable={props.editable && jogo.simular}
									jogo={jogo}
									simulados={simulados}
									ida_volta={ida_volta}
									updateSimulado={props.updateSimulado}
									primeira_posicao={props.primeira_posicao}
									segunda_posicao={props.segunda_posicao}
									showAllSimulados={props.showAllSimulados}
									no-lines={true}
								/>
							})}
						</span>
						<span className="e100"/>
					</>
				:
					null
				)}
			</div>
		</div>
	);
}

export default function Chaves(props) {
	const [ state, setState, render ] = useLoadState(

		{ chaves: [] },

		() => { return [ props.campeonato, props.simulados ] },

		() => { return [ { url: "campeonato/" + props.campeonato + "/chaves", params: { simulados: props.simulados } } ]; },

		(result) => {
			setState((state) => ({ ...state, chaves: result[0].result.turno, turnoAtual: result[0].result.atual }))
		},

		true
	);

	return (
		<>
		{/*<div className="chave-container">*/}
		{state.chaves.map(turno => (
			turno.fases.map(fase => {
				const extra_jogos = fase.extra_jogos;
				return <div key={fase.id_fase} className="column">
					<div className="column-header">{fase.name}</div>
					<div className="column-legenda">{extra_jogos ? "Toque no Nome/Bandeira da Seleção para escolher a Campeã" : "Toque no Nome/Bandeira da Seleção para escolher a classificada"}</div>
					{fase.jogos.map((jogo,i) => {
						const updateSimulado = function(id, type, value, type2, value2) {
							props.onUpdateSimulado(id, type, value, type2, value2);
						};
						return <Jogo key={i} editable={props.editable}
							clubeMap={props.clubeMap}
							jogo={jogo}
							simulados={props.simulados}
							count={fase.jogos.length}
							ida_volta={fase.ida_volta}
							extra_jogos={extra_jogos}
							updateSimulado={updateSimulado}
							primeira_posicao={props.primeira_posicao}
							segunda_posicao={props.segunda_posicao}
							showAllSimulados={props.showAllSimulados}
							no-lines={!!extra_jogos}
							/>
					})}
					<div className="fill"/>
				</div>
			})
		))}
		{/*</div>*/}
		{render(() => null)}
		</>
	);
}
